<div class="data-sources-panel">
    @if (sourceSelectedId !== '' && sourceSelectedId !== bbceSourceId) {
    <div class="items-list-header">
        @if (!selectionMode()) {
        <button-induxtry [buttonProperties]="{
          label: 'Executar séries',
          icon: 'Play',
          customStyle: 'secondary',
          showLabel: true,
          customStyleFillIcon: true,
          key: 'executarSeries',
          tooltip: 'Selecionar séries para executar'
        }" (action)="enterSelectionMode()">
        </button-induxtry>
        <button-induxtry [buttonProperties]="{
          label: 'Incluir dataset',
          icon: 'Plus',
          customStyle: 'primary',
          showLabel: true,
          key: 'addSeries'
        }" (action)="onAddSeriesClick($event)">
        </button-induxtry>
        } @else {
        <div class="selection-actions">
            <button-induxtry [buttonProperties]="{
              label: areAllSelected() ? 'Desmarcar todas' : 'Selecionar todas',
              icon: areAllSelected() ? 'circle-cancel' : 'circle-success',
              customStyle: 'secondary',
              showLabel: true,
              customStyleFillIcon: true,
              key: 'selectAll'
            }" (action)="toggleSelectAllGlobal()">
            </button-induxtry>
            @if (selectedCount() > 0) {
            <button-induxtry [buttonProperties]="{
              label: 'Executar (' + selectedCount() + ')',
              icon: 'Play',
              customStyle: 'primary',
              customStyleFillIcon: true,
              showLabel: true,
              key: 'runExecutions',
              loading: isExecuting()
            }" (action)="onRunExecutionsClick($event)">
            </button-induxtry>
            }
            <button-induxtry [buttonProperties]="{
              label: 'Cancelar',
              customStyle: 'secondary',
              showLabel: true,
              key: 'cancelSelection'
            }" (action)="exitSelectionMode()">
            </button-induxtry>
        </div>
        }
    </div>
    }

    @if (datasets.length > 0) {
    <div class="items-list" role="list">
        <mat-accordion multi="true">
            @for (dataset of datasets; track dataset._id) {
            <mat-expansion-panel
                [expanded]="isDatasetExpanded(dataset._id)"
                (opened)="onDatasetOpened(dataset._id)"
                (closed)="onDatasetClosed(dataset._id)">
                <mat-expansion-panel-header>
                    @if (selectionMode()) {
                    <mat-checkbox color="primary" [checked]="isAllSelectedInDataset(dataset._id)"
                        (change)="toggleAllInDataset(dataset._id); $event.stopPropagation()" (click)="$event.stopPropagation()"
                        aria-label="Selecionar todas as séries deste dataset">
                    </mat-checkbox>
                    }
                    @if (!selectionMode() && getDatasetStatusIcon(dataset); as statusIcon) {
                    <icon-induxtry
                        [icon]="{icon: statusIcon, width: '24px', height: '24px'}"></icon-induxtry>
                    }
                    <span class="mx-2 item-name" [title]="dataset.name">
                        {{ dataset.name }}
                    </span>
                </mat-expansion-panel-header>
                <div class="item-content">
                    <span class="item-description" [title]="dataset.description">
                        {{ dataset.description ?? 'Nenhuma descrição fornecida' }}
                    </span>
                    <div class="item-row-content-series">
                        @if (loadingSeriesDatasetId === dataset._id && getSeries(dataset._id).length === 0) {
                        <span class="item-description">Carregando séries...</span>
                        }
                        @for (series of getSeries(dataset._id); track series._id) {
                        <div class="item-row-content" (click)="onItemClick(series, $event)"
                            (keydown.enter)="onItemClick(series, $event)"
                            (keydown.space)="onItemClick(series, $event); $event.preventDefault()"
                            [attr.aria-label]="'Série ' + series.name + ' - ' + (series.unit ?? '')" tabindex="0"
                            [class.selected]="!selectionMode() && isSelectedItemId === series._id">

                            @if (selectionMode()) {
                            <mat-checkbox color="primary" [checked]="isSeriesSelected(series)"
                                (change)="toggleSelection(series); $event.stopPropagation()"
                                (click)="$event.stopPropagation()"
                                [attr.aria-label]="'Selecionar série ' + series.name">
                            </mat-checkbox>
                            }
                            @if (series.last_job_execution?.status) {
                            <icon-induxtry
                                [icon]="{icon: seriesStatusIcon[series.last_job_execution?.status], width: '24px', height: '24px'}"></icon-induxtry>
                            }
                            <div class="item-content">
                                <div class="item-series-header">
                                    <span class="item-name" [title]="series.name">
                                        {{ series.name }}
                                    </span>
                                    <span class="item-last-execution">
                                        Última execução: {{ series.last_job_execution?.updatedAt | date:'dd/MM/yyyy, HH:mm' }}
                                    </span>
                                </div>
                            </div>

                            @if (!selectionMode()) {
                            <div class="item-row-content-series-buttons">
                                <icon-action-button (clicked)="onDeleteItemClick(series, $event)" [ariaLabel]="'Excluir série'"
                                    [icon]="'delete'" [type]="'delete'" [disabled]="false">
                                </icon-action-button>
                            </div>
                            }
                        </div>
                        }
                        @if (loadingSeriesDatasetId !== dataset._id && getSeries(dataset._id).length === 0) {
                        <span class="item-description">Nenhuma série cadastrada</span>
                        }
                    </div>
                </div>
            </mat-expansion-panel>
            }
        </mat-accordion>
    </div>
    } @else {
    <div class="empty-state">
        <icon-induxtry [icon]="{icon: 'file'}"></icon-induxtry>
        @if (sourceSelectedId !== '') {
        <h3>Nenhum item encontrado</h3>
        <span>Nenhum item encontrado para a conexão selecionada</span>
        } @else {
        <h3>Nenhuma conexão selecionada</h3>
        <span>Selecione um item na barra lateral esquerda para visualizar os dados</span>
        }
    </div>
    }
</div>
